import accountHelper from "@/utils/helpers/account";
import dateHelper from "@/utils/helpers/date";
import freshdesk from "@/utils/helpers/freshdesk";
import buildLink from "@/api/helpers/freshdesk/buildLink";

function createRescheduleBody(payload, isAbsence) {
  let { order, newData, tags } = payload;
  return {
    email: order.customer.account.email,
    subject: createRescheduleSubject(order.customer, order.schedule_event),
    tags: ["Automatico", "Reagendamento"].concat(tags),
    description: createRescheduleDescription(order, newData, isAbsence),
    priority: freshdesk.getTicketPriority("high"),
    status: freshdesk.getTicketStatusCode("open"),
    group_id: freshdesk.getGroupIds("customer_experience"),
    type: "[sou cliente] Reagendar/Cancelar uma limpeza"
  };
}

const createRescheduleSubject = (customer, schedule_event) =>
  `Solicitação de Reagendamento - ${accountHelper.fullName(
    customer.account
  )} (${dateHelper.getDate(schedule_event.starts_at)})`;

const createRescheduleDescription = (order, newData, isAbsence) =>
  `Olá, meu nome é ${buildLink.customer(order.customer)} ${absencePrefix(
    isAbsence
  )} reagendar a minha limpeza!</br></br><b>
    Dados originais da limpeza:</b></br><b>Link da limpeza:</b> ${buildLink.order(
      order.id
    )}</br><b>Dia:</b> ${dateHelper.getDate(
    order.schedule_event.starts_at
  )}</br><b>Início:</b> ${dateHelper.getHour(
    order.schedule_event.starts_at
  )}hrs</br><b>Profissional:</b> ${buildLink.professional(
    order.professional
  )}</br></br><b>Preciso que seja reagendado da seguinte forma:</b></br><b>Dia:</b> ${dateHelper.getDate(
    newData.day
  )}</br><b>Início:</b> ${
    newData.startsAt
  }hrs</br><b>Profissional:</b> ${getProfessionalOptionText(
    newData.keepProfessional
  )}`;

const absencePrefix = isAbsence => {
  return isAbsence
    ? "e a profissional não compareceu a limpeza que eu contratei. Devido a essa falta, quero"
    : "agendei uma limpeza com o aplicativo Donamaid e gostaria de ";
};

const getProfessionalOptionText = keepProfessional =>
  keepProfessional
    ? "Prefiro tentar reagendar com o mesmo profissional autônomo que agendei"
    : "Não tenho preferência por profissional autônomo específico";

export default { createRescheduleBody };



// WEBPACK FOOTER //
// ./src/api/helpers/freshdesk/reschedule.js